import { render, staticRenderFns } from "./member-detail.vue?vue&type=template&id=0b98bba6&scoped=true"
import script from "./member-detail.vue?vue&type=script&lang=js"
export * from "./member-detail.vue?vue&type=script&lang=js"
import style0 from "./member-detail.vue?vue&type=style&index=0&id=0b98bba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98bba6",
  null
  
)

export default component.exports